import cn from "classnames"
import React from "react"
import { useTranslation } from "react-i18next"

import { FormRadio } from "../Radio/Radio"
import styles from "./index.module.css"

type RadioBundleProps = {
  className?: string
  items?: Items[]
}

type Items = {
  label: string
  name: string
  value: string
}

export const RadioBundle: React.FC<RadioBundleProps> = ({ className, items }) => {
  const { t } = useTranslation()

  items = !items
    ? [
        {
          label: t("popup.Default.Form.Subject.Organization.Label"),
          name: "organisation",
          value: "organisation",
        },
        {
          label: t("popup.Default.Form.Subject.PrivatePerson.Label"),
          name: "organisation",
          value: "privatePerson",
        },
      ]
    : items

  return (
    <div className={cn(className, styles.Wrapper)}>
      {items.map(({ label, name, value }) => (
        <FormRadio key={label} label={label} name={name} value={value} />
      ))}
    </div>
  )
}
